import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { DefaultErrorPage } from './components/default-error-page';
import { routeTree } from './routeTree.gen';

import { IAuthContext } from '@auth/data-access';
import { DefaultPendingComponent, NotFound } from '@ui';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    auth: undefined as unknown as IAuthContext, // This will be set after we wrap the app in an AuthProvider
    queryClient: undefined as unknown as QueryClient, // This will be set after we wrap the app in a QueryClientProvider
  },
  defaultNotFoundComponent: NotFound,
  defaultPendingComponent: DefaultPendingComponent,
  defaultErrorComponent: DefaultErrorPage,
});
